const MUTE_KEY = 'sprinters.muted';

let context: AudioContext | null = null;
let muted = readMuted();

function readMuted(): boolean {
  try {
    return localStorage.getItem(MUTE_KEY) === '1';
  } catch {
    return false;
  }
}

function getContext(): AudioContext | null {
  if (typeof AudioContext === 'undefined') return null;
  context ??= new AudioContext();
  if (context.state === 'suspended') void context.resume();
  return context;
}

function beep(
  frequency: number,
  durationMs: number,
  volume = 0.08,
  type: OscillatorType = 'square',
): void {
  if (muted) return;
  const ctx = getContext();
  if (!ctx) return;
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = type;
  oscillator.frequency.value = frequency;
  const now = ctx.currentTime;
  gain.gain.setValueAtTime(volume, now);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + durationMs / 1000);
  oscillator.connect(gain).connect(ctx.destination);
  oscillator.start(now);
  oscillator.stop(now + durationMs / 1000);
}

export const sounds = {
  tick: (): void => beep(660, 120),
  go: (): void => beep(1320, 350),
  fall: (): void => beep(140, 260, 0.12, 'sawtooth'),
  finish: (): void => {
    beep(880, 120, 0.07, 'triangle');
    setTimeout(() => beep(1175, 220, 0.07, 'triangle'), 120);
  },
};

export function isMuted(): boolean {
  return muted;
}

export function setMuted(value: boolean): void {
  muted = value;
  try {
    localStorage.setItem(MUTE_KEY, value ? '1' : '0');
  } catch {
    // Stockage indisponible : le réglage vaut pour la session.
  }
}

/** À appeler lors d'un geste utilisateur pour débloquer l'audio sur les navigateurs stricts. */
export function unlockAudio(): void {
  getContext();
}
